import React, { useEffect, useState } from "react";

function InventoryCard({ number, children, icon, cardColor = "#4faab9" }) {
  const [stateNumber, setStateNumber] = useState(0);
  useEffect(() => {
    for (let i = 0; i <= number; i++) {
      setTimeout(() => setStateNumber(i), 200);
    }
  }, [number]);

  return (
    <div className="details-card-inv shadow-card">
      <div className="detail-icon">{icon}</div>
      <span className="total-info" style={{ color: cardColor }}>
        {stateNumber}
      </span>
      {children}
    </div>
  );
}

export default InventoryCard;
